// LICENSE_CODE ZON
/*jslint ts:true, react: true*/
import React, {useState, useMemo, ChangeEvent, Fragment} from 'react';
import Country_pins_hola from '../../../img/hola2023/country_pins.svg';
import Country_pins_toolip from '../../../../../toolip/pub/img/country_pins.svg';
import styles from './configure_proxies.module.less';
import {use_theme} from '../../../settings_ctx';
import cn from 'classnames';
// @ts-ignore
import {get_country_object} from '/util/country.js';
import {Select} from '../../../lib/select';
import {Button} from '../../../lib/button';
import {Flag} from '../../../lib/flag';
import {Modal} from '../../../lib/modal';
// @ts-ignore
import {Tooltip} from '../../../lib/tooltip.js';
import Icon_question from '../../../img/hola2023/icons/16/question.svg';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import etask from 'zetask';
import {Proxy_type, i_row_data} from './orders';
// @ts-ignore
import date from '/util/date.js';
import {Range_input} from '../../../lib/range_input';

type t_country_object = {
  code: string; // alpha-2 like "us" or "il"
  name: string;
  name_low: string;
  name_locale: string;
  top: boolean;
}

const type_to_csv_name = (type:Proxy_type)=>{
    switch (type)
    {
      case Proxy_type.DDC:
          return 'DDC';
      case Proxy_type.ISP:
          return 'ISP';
      case Proxy_type.SDC:
          return 'SDC';
      default:
          return 'proxy';
    }
};

const download_text = (fn, text)=>{
    const el = document.createElement('a');
    el.setAttribute('href', 'data:text/plain;charset=utf-8,'
      +encodeURIComponent(text));
    el.setAttribute('download', fn);
    el.style.display = 'none';
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
};

const proxy_to_csv = proxies=>{
    const csv = [['login', 'password', 'host', 'port']];
    for (let p of proxies)
        csv.push([p.login, p.password, p.host, p.port]);
    return csv.map(x=>x.join(',')).join('\n');
};

interface i_with_label_props {
    label: string;
    tooltip_content?: JSX.Element;
    children?: React.ReactNode;
}
const With_label = (props:i_with_label_props)=>{
    const {label, children, tooltip_content} = props;
    const {theme} = use_theme();
    return <div className={styles.label_wrapper}>
      <div className={styles.label_header}>
        <p className={cn(theme.p5, theme.med)}>{label}</p>
        {tooltip_content && <Tooltip content={tooltip_content}
          cls_cn={styles.tooltip_content}>
          <Icon_question/>
        </Tooltip>}
      </div>
      {children}
    </div>;
};

interface i_country_block {
    item: t_country_object;
    cls?: string;
}
const Country_block = (props: i_country_block)=>{
    const {item, cls} = props;
    const {theme} = use_theme();
    return <div className={styles.country}>
      <Flag cls={styles.flag} country={item.code} size={32} round />
      <p className={cn(theme.logo_grey, cls)}>{item.name}</p>
    </div>;
};

interface i_country_list_props {
    country?: string;
    on_country_change: (next_value: string)=>void;
    all: t_country_object[];
}
const Country_list = (props: i_country_list_props)=>{
    const [inited, set_inited] = useState(false);
    const {all, on_country_change, country} = props;
    const {theme} = use_theme();
    const items = useMemo(()=>
        all.map(x=>({
            value: x.code,
            title: <Country_block item={x}
              cls={cn(theme.p3, theme.reg, styles.label_text)}/>,
            rendered_item: <Country_block item={x}
              cls={cn(theme.p4, theme.med, styles.list_text)}/>,
        })), [all]);
    const on_select = (name, value)=>{
        on_country_change(value);
        set_inited(true);
    };
    return <With_label label="Country">
      <Select items={items} value={country}
        field_cls={cn(styles.field, !inited && styles.init_state)}
        on_select={on_select} borderless size="lg"/>
    </With_label>;
};

type t_preset = {
  id: string;
  title: string;
  value: number | null;
};

const QUANTITY_PRESETS_CUSTOM: t_preset =
  {id: 'custom', title: 'Custom', value: null};

const QUANTITY_PRESETS: t_preset[] = [
    {id: 'p1', value: 1, title: '1'},
    {id: 'p2', value: 10, title: '10'},
    {id: 'p3', value: 20, title: '20'},
    QUANTITY_PRESETS_CUSTOM,
];

interface i_input_slider_props {
    quantity?: number;
    on_quantity_change: (next_value: number)=>void;
    is_show_disabled_slider?: boolean;
    ips_amount: number;
}

const Quantity_select = (props: i_input_slider_props)=>{
    const {quantity = 0, on_quantity_change,
        is_show_disabled_slider = false, ips_amount} = props;
    const {theme} = use_theme();
    const [preset, set_preset] = useState(()=>{
        if (ips_amount < 1000)
            return QUANTITY_PRESETS_CUSTOM;
        if (quantity!=null && quantity > 0)
        {
          return QUANTITY_PRESETS.find(p=>p.value==quantity)
              ?? QUANTITY_PRESETS_CUSTOM;
        }
        return QUANTITY_PRESETS[0];
    });

    const on_preset_select = (next_preset: t_preset)=>{
        set_preset(next_preset);
        // when switching to custom, we always set slider's value to
        // the current quantity value, so we should not change quantity
        if (next_preset.id!='custom')
            on_quantity_change(next_preset.value);
    };

    const is_show_slider = ips_amount < 1000 ||
        is_show_disabled_slider || preset.id=='custom';
    const disabled = preset.id!='custom';

    return <With_label label="Quantity">
      <div className={styles.quantity_container}>
        {ips_amount >= 1000 && <div className={styles.presets_container}>
          {QUANTITY_PRESETS.map(x=>
            <button type="button" key={x.id} onClick={()=>on_preset_select(x)}
              className={cn(styles.quantity,
                preset.id==x.id&&styles.active)}>
              <p className={theme.p4}>{x.title}</p>
            </button>)}
        </div>}
          {is_show_slider &&
            <Range_input min={1} max={ips_amount} step={1}
              disabled={disabled}
              thumb_size={20}
              tracker_with_ref={(ref, val)=>
                <div className={cn(disabled && styles.disabled,
                styles.custom_value)} ref={ref}>
                  {!disabled &&
                    <p className={cn(theme.p4, theme.med)}>
                      {val?.toLocaleString()}</p>}
                </div>} container_cls={styles.custom_container}
                on_change={on_quantity_change}
                value={quantity}
            />}
      </div>
    </With_label>;
};

interface i_input_protocol_props {
  is_socks5: boolean;
  on_is_socks5_change: (next_value: boolean)=>void;
}

const Protocol_select = (props: i_input_protocol_props)=>{
  const {is_socks5, on_is_socks5_change} = props;
  const on_change = (ev: ChangeEvent<HTMLInputElement>)=>
      on_is_socks5_change(ev.target.value=='socks5');

  const {theme} = use_theme();
  return <With_label label={'Proxy protocol'}>
      <div className={styles.protocol_container}>
        <label className={cn(!is_socks5 && styles.checked)}>
          <input type="radio" value="https" name="protocol"
            checked={!is_socks5} onChange={on_change} />
          <p className={cn(theme.p5, theme.reg)}>HTTP/HTTPS</p>
        </label>

        <label className={cn(is_socks5 && styles.checked)}>
          <input type="radio" value="socks5" name="protocol"
            checked={is_socks5} onChange={on_change} />
          <p className={cn(theme.p5, theme.reg)}>SOCKS5</p>
        </label>
      </div>
    </With_label>;
};

type t_configure_proxies_props = {
    row: i_row_data;
    on_close: ()=>void;
    on_orders_refresh: ()=>void;
    type: Proxy_type;
    countries?: string[]; // null for type=dedicated_dc
    user_ip: string;
    configure_proxies_url: string;
    is_show_disabled_slider?: boolean;
    is_only_update_mode?: boolean;
};

export const Configure_proxies=(props: t_configure_proxies_props)=>{
    const {row, countries, on_close, on_orders_refresh, ...other} = props;
    const country_objects: t_country_object[] = useMemo(
      ()=>countries?.map(x=>get_country_object(x))
        ?.sort((a, b)=>a.name_low.localeCompare(b.name_low)) ?? [],
      [countries]);
    const on_success = ()=>{
      on_orders_refresh();
      on_close();
    };

    return <Modal is_open={!!row} on_close={on_close}
      no_logo width={604} paddingless on_overlay_click={()=>undefined}>
      {!!row && <Configure_proxies_internal
        key={`proxies_${row.create_date}`}
        {...other}
        country_objects={country_objects}
        row={row}
        on_success={on_success} />}
    </Modal>;
};

type t_configure_proxies_internal_props = {
    type: Proxy_type;
    row: i_row_data;
    on_success: ()=>void;
    country_objects: t_country_object[]; // empty for type=dedicated_dc
    configure_proxies_url: string;
    user_ip: string;
    is_show_disabled_slider?: boolean;
    is_only_update_mode?: boolean;
}

const Configure_proxies_internal=(props:t_configure_proxies_internal_props)=>{
    const {theme, theme_name} = use_theme();
    const {row, on_success, type, country_objects,
        configure_proxies_url,
        is_show_disabled_slider,
        is_only_update_mode} = props;

    const [country, on_country_change] = useState('us');
    const [quantity, on_quantity_change] = useState(QUANTITY_PRESETS[0].value);
    const [is_socks5, on_is_socks5_change] = useState(false);

    const [is_loading, set_is_loading] = useState(false);
    const update_proxy = ()=>etask(function*(){
      let res = null;
      set_is_loading(true);
      try {
        const other_params = type=='dedicated_dc' || type=='isp_plus' ? {}
        : {quantity, country, socks5: is_socks5 ? 'true' : 'false'};
        res = yield fetch(configure_proxies_url, {
          method: 'POST',
          body: {id: row.id, ...other_params},
        });
      } finally {
        set_is_loading(false);
      }
      return res;
    });
    const on_update_click = ()=>etask(function*(){
      yield update_proxy();
      on_success();
    });
    const on_download_click = ()=>etask(function*(){
        try {
            (window as any).dataLayer.push({
              event: 'gtag.download_proxy'
            });
        } catch(e){}
        try {
          const res = yield update_proxy();
          if (res?.res)
          {
              const {proxies} = res.res;
              const text = proxy_to_csv(proxies);
              const t = type_to_csv_name(type);
              const csv_fn = (theme_name=='toolip' ? 'toolip' : 'HolaPro')
                  +`-${t}-`
                  +(country && type!='dedicated_dc'
                      ? `${country.toUpperCase()}-` : '')
                  +`${row.fn}-${date.strftime('%d-%b-%y', new Date())}.csv`;
              download_text(csv_fn, text);
              on_success();
          }
          // XXX evgeniis: else show error message
        } finally {
        }
    });

    const Image = theme_name=='toolip'
        ? Country_pins_toolip : Country_pins_hola;

    return <div className={
      cn(
        styles.configure_proxies_container,
        theme_name=='toolip' && styles.toolip,
        'configure_proxies')}>
      <div className={styles.image_container}>
        <Image className={cn(styles.pins,
          type==='dedicated_dc' && styles.short)}/>
      </div>
      <div className={styles.setup_container}>
        <div className={styles.header}>
          <h5>Configure Proxies</h5>
          <p className={cn(theme.p3, theme.reg)}>
            Set up your proxy list</p>
        </div>
        <div className={styles.inputs_container}>
          {type=='dedicated_dc' || type=='isp_plus' ? <Fragment></Fragment>
          : <Fragment>
            <Country_list
              country={country}
              on_country_change={on_country_change}
              all={country_objects} />
            {is_only_update_mode ?
              <p className={theme.p2}>Quantity: {quantity}</p> :
              <Quantity_select
                ips_amount={row.ips_amount}
                quantity={quantity}
                on_quantity_change={on_quantity_change}
                is_show_disabled_slider={is_show_disabled_slider} />}
            {theme_name=='toolip' && !is_only_update_mode &&
                <Protocol_select
                  is_socks5={is_socks5}
                  on_is_socks5_change={on_is_socks5_change} />}
          </Fragment>}
        </div>
        {is_only_update_mode ?
          <Button caption="Update" disabled={is_loading}
            color="black" no_jump on_click={on_update_click}
            round cls={styles.btn_download}/>:
          <Button caption="Download CSV file" disabled={is_loading}
            color="black" no_jump on_click={on_download_click}
            round cls={styles.btn_download}/>}
        </div>
    </div>;
};
